<template>
  <div>
    <div class="dataCollectionPages">
      <div class="activity-header-container">
        <div
          class="activity-header"
          :style="{
            paddingTop: stateHeight,
            background: bgColor,
          }"
        >
          <van-nav-bar :border="false" class="navbar" placeholder>
            <template #left>
              <div class="left">
                <img
                  class="icon-back"
                  src="../assets/img/activity/icon-back.png"
                  @click="handleBack"
                />
              </div>
            </template>
            <template v-if="sendSucceed && !sendSucceedShow" #title>
              <span>投递成功</span>
            </template>
          </van-nav-bar>
        </div>
      </div>
      <div
        class="dataCollectionPages_wrap"
        :style="{
          paddingTop: parseInt(stateHeight) + 48 + 'px',
        }"
      >
        <template v-if="sendSucceed">
          <div class="send_success" v-if="sendSucceedShow">
            <div class="success_animation" ref="animRef"></div>
            <div class="success_text">投递成功</div>
          </div>
          <div class="con_top_success">
            <div class="qs_tit">HR想询问以下问题</div>
            <div class="qs_subhead">回答后有助于提高应聘成功率</div>
            <img
              class="qs_bg"
              src="../assets/img/activity/data/wechat_success.png"
              alt=""
            />
          </div>
        </template>

        <div v-else class="con_top">
          <div class="qs_tit">HR想询问以下问题</div>
          <div class="qs_subhead">回答后有助于提高应聘成功率</div>
          <img
            class="qs_bg"
            src="../assets/img/activity/data/wechat_big.png"
            alt=""
          />
        </div>
        <div class="questions_wrap" v-for="item in dataList" :key="item.jobId">
          <div class="questions_tit">
            <img
              class="qs_img"
              src="../assets/img/activity/data/q.png"
              alt=""
            />
            <span>{{ item.jobName }}</span
            >职位相关问题：
          </div>
          <div v-for="question in item.questionList" :key="question.questionId">
            <div class="q_item_tit">{{ question.questionDesc }}</div>
            <div class="q_selects">
              <div
                class="skill"
                :class="option.choose && 'skill_active'"
                v-for="option in question.optionList"
                :key="option.code"
                @click="selectQuestion(question, option)"
              >
                {{ option.name }}
                <img
                  v-if="option.choose"
                  class="select_icon"
                  src="../assets/img/activity/data/selected.png"
                  alt=""
                />
                <img
                  v-else
                  class="select_icon"
                  src="../assets/img/activity/data/unselect.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom_btn">
        <div class="save_btn" @click="saveCollectData">保存</div>
        <div class="save_tip">
          为了向您提供完整的求职服务，请您同意我们获取您的必要信息。如您不同意，请不要填写
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import lottie from "lottie-web/build/player/lottie_light.js";
import router from "@/router";
export default {
  name: "DataCollectionPages",
  components: {},
  data() {
    return {
      loading: true,
      finished: false,
      jobError: false,
      pageNum: 1,
      totalCount: 0,
      qaList: [],
      stateHeight: 0,
      bgColor: "",
      coInfo: {},
      jobInfo: {},
      queryData: this.$route.query || {},
      lottieAni: "",
      sendSucceedShow: true,
      collectDataList: [],
      source: 1,
      jobIdList: [],
      dataList: [],
      actTit: "",
    };
  },
  created() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    this.source = this.queryData.source;
    let jobQuestionSets = JSON.parse(
      this.$store.state.commonStore.jobQuestionSets
    );
    this.jobIdList = jobQuestionSets.jobIdList;
    this.dataList = jobQuestionSets.dataList;
    // skillsOrPreferencesCodeList
    console.log(jobQuestionSets);
    this.dataList.forEach((item) => {
      item.questionList.forEach((question) => {
        question.optionList.forEach((option) => {
          let selected = jobQuestionSets.skillsOrPreferencesCodeList.includes(
            option.code
          );
          if (selected) {
            this.$set(option, "choose", true);
          } else {
            this.$set(option, "choose", false);
          }
        });
      });
    });
  },
  async mounted() {
    if(this.$store.state.commonStore.searchPage){
      this.stateHeight = '0px'
    }else{
      this.stateHeight = await this.$base.getAppStateHeight();
    }
    this.playAnim();
    this.lottieAni.play();
    this.lottieAni.addEventListener("complete", () => {
      this.sendSucceedShow = false;
    });
    window.addEventListener("scroll", this.handleScroll);
  },
  computed: {
    sendSucceed() {
      return this.source == 1;
    },
  },
  methods: {
    selectQuestion(question, option) {
      let optionType = question.optionType; //单选或双选, 1-单选；2-多选
      let optionList = question.optionList;
      console.log(optionType);
      if (optionType == 1) {
        //单选
        optionList.forEach((optionItem) => {
          if (optionItem.choose && optionItem.code !== option.code) {
            optionItem.choose = false;
          }
        });
      }

      if (option.choose) {
        option.choose = false;
      } else {
        // this.$set(option, "choose", true);
        option.choose = true;
      }

      // console.log(this.collectDataList);
    },
    async saveCollectData() {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_save",
      });
      const params = {
        accountId: this.$store.state.commonStore.accountId,
        source: this.source, //来源：1-投递页；2-弹窗页
        jobIdList: this.jobIdList, //source=1时必传
        collectDataList: this.dataList, //问题答案列表
      };
      const res = await this.$api.activity.saveCollectData(params);
      if (+res?.code == "0") {
        this.handleBack();
      }
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 0) {
        this.bgColor = "#ffffff";
        this.actTit = "投递成功";
      } else {
        this.bgColor = "";
        this.actTit = "";
      }
    },
    handleBack() {
      router.go(-1);
      // const sessionData = sessionStorage.getItem(this.queryData.activityId);
      // const { func, city } = sessionData ? JSON.parse(sessionData) : {};
      // this.$router.push({
      //   path: `/op/${this.queryData.activityId}`,
      //   query: {
      //     func,
      //     city,
      //   },
      // });
    },
    playAnim() {
      const animation = require(`../assets/img/activity/data/success.json`);
      this.lottieAni = lottie.loadAnimation({
        container: this.$refs.animRef,
        renderer: "svg",
        loop: false,
        autoplay: false,
        animationData: animation,
      });
    },
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style scoped lang="less">
.dataCollectionPages {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  .dataCollectionPages_wrap {
    padding-bottom: 130px;
    padding-top: 48px;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding: 48px 0 130px;
    .send_success {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 8px 0 30px;
      .success_animation {
        height: 40px;
        width: 40px;
        margin-right: 10px;
      }
      .success_text {
        font-size: 22px;
        font-weight: 500;
        color: #222222;
      }
    }

    .con_top_success {
      background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 117, 29, 0.15) 98%
      );
      border-top: 1px solid #ffce9f;
      border-image: linear-gradient(
        180deg,
        #ffce9f 0%,
        rgba(255, 255, 255, 0) 100%
      );
      position: relative;
      // margin-top: 23px;
      padding: 13px 16px 19px;
      border-radius: 12px 12px 0px 12px;
      .qs_tit {
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
        letter-spacing: 0px;
        color: #222222;
      }
      .qs_subhead {
        font-size: 14px;
        font-weight: normal;
        line-height: 20px;
        letter-spacing: 0px;
        color: #222222;
        margin-top: 2px;
      }
      .qs_bg {
        width: 76px;
        position: absolute;
        right: 22px;
        top: 8px;
      }
    }
    .con_top {
      position: relative;
      margin-bottom: 20px;
      padding: 8px 16px 0;
      .qs_tit {
        font-size: 24px;
        font-weight: 600;
        line-height: 28px;
        letter-spacing: 0px;
        color: #222222;
      }
      .qs_subhead {
        font-size: 16px;
        font-weight: normal;
        line-height: 17px;
        letter-spacing: 0px;
        color: #7c8087;
        margin-top: 8px;
      }
      .qs_bg {
        width: 96px;
        position: absolute;
        top: 0;
        right: 10px;
      }
    }
    .questions_wrap {
      padding: 0 16px;
      .questions_tit {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        line-height: 26px;
        letter-spacing: 0px;
        color: #222222;
        margin-bottom: 16px;
        margin-top: 16px;
        .qs_img {
          width: 18px;
          height: 18px;
          margin-right: 6px;
        }
        span {
          color: #ff5500;
          max-width: 198px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .q_item_tit {
        font-size: 14px;
        font-weight: 600;
        line-height: 17px;
        letter-spacing: 0px;
        color: #222222;
      }
      .q_selects {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 24px;
        .skill {
          border-radius: 6px;
          opacity: 1;
          background: #f2f4f7;
          font-size: 14px;
          line-height: 16px;
          letter-spacing: 0px;
          color: #4c4f54;
          padding: 13px 12px;
          margin: 12px 12px 0 0;
          position: relative;
          .select_icon {
            width: 10px;
            height: 10px;
            position: absolute;
            right: 0;
            top: 0;
          }
        }
        .skill_active {
          color: #ff5500;
          background: #fff1eb;
          font-weight: 600;
        }
      }
    }
  }
  .bottom_btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 107px;
    background: #ffffff;
    .pc & {
      width: 375px;
      left: 50%;
      transform: translateX(-50%);
    }
    .save_btn {
      width: 343px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      background: #ff6c0e;
      border-radius: 4px;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      margin: auto;
      margin-top: 9px;
      cursor: pointer;
      border-radius: 22px;
    }
    .save_tip {
      font-size: 8px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0px;
      color: #cbced4;
      margin-top: 9px;
      text-align: center;
    }
  }
  .activity-header-container {
    position: relative;
    .activity-header {
      min-height: 44px;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 999;
      .pc & {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 999;
        width: 375px;
      }
      .left {
        display: flex;
      }
      /deep/.van-nav-bar {
        height: 44px;
        width: 100%;
        .van-nav-bar__content {
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 16px 0 16px;
          position: relative;
          .van-nav-bar__title {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-size: 16px;
          }
        }
      }
      .icon-back {
        display: inline-block;
        width: 24px;
        height: 24px;
      }
    }
  }
  .loading {
    text-align: center;
    // font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #000000;
    line-height: 18px;
    margin: 15px 0 25px 0;
  }
  /deep/ .van-list__loading {
    margin: 11px 0 27px 0;
    .van-loading--circular {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .van-loading__circular {
      display: none;
    }
    .van-loading__spinner--circular {
      height: 16px !important;
      display: block;
      width: 14px !important;
    }
    .van-loading__spinner--circular::after {
      content: "";
      background-image: url("~@/assets/img/activity/loading@2x.png");
      background-size: cover;
      height: 16px;
      display: block;
      width: 14px;
      background-repeat: no-repeat;
      animation: rotate 1.5s linear infinite;
    }
    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
    .van-loading__text {
      font-weight: 400;
      font-size: 13px;
      color: #4e4e4e;
      margin-left: 6px;
    }
  }
  /deep/ .van-list__error-text,
  /deep/ .van-list__finished-text,
  /deep/ .van-list__loading {
    color: #4e4e4e;
    text-align: center;
    margin: 11px 0 0px 0;
  }
}
.dataCollectionPages::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 229px;
  background: linear-gradient(
    180deg,
    rgba(255, 117, 29, 0.1) 0%,
    rgba(255, 255, 255, 0) 20%
  );
  // background: linear-gradient(
  //   180deg,
  //   rgba(255, 29, 97, 0.8) 0%,
  //   rgba(24, 9, 236, 0.226) 20%
  // );
}
</style>
